import { Schedule } from "source/giving/donate/form/types"
import { RecurringDonationStatus } from "../types"
import EditStatus from "./EditStatus"
import EditFrequency from "./EditFrequency"
import NextOccurrence from "./NextOccurrence"

interface EditScheduleProps {
  schedule: Schedule
  status: RecurringDonationStatus
  releaseHoldAt: string | null
  nextOccurrence: string | null
  onChangeFrequency: (frequency: Schedule) => void
  onChangeStatus: (
    status: RecurringDonationStatus,
    releaseHoldAt: string | null,
  ) => void
  onChangeReleaseHoldAt: (releaseHoldAt: string | null) => void
  onChangeNextOccurrence: (nextOccurrence: string | null) => void
}

export default function EditSchedule({
  schedule,
  status,
  releaseHoldAt,
  nextOccurrence,
  onChangeFrequency,
  onChangeStatus,
  onChangeReleaseHoldAt,
  onChangeNextOccurrence,
}: EditScheduleProps) {
  return (
    <div>
      <div className="mb-2">
        <label
          htmlFor="recurring_donation[schedule]"
          style={{ marginBottom: -16 }}
        >
          Frequency
        </label>
        <EditFrequency
          schedule={schedule}
          nextOccurrenceDate={nextOccurrence || new Date().toLocaleString()}
          onChangeFrequency={onChangeFrequency}
        />
      </div>
      <div>
        <EditStatus
          status={status}
          releaseHoldAt={releaseHoldAt}
          onChangeStatus={onChangeStatus}
          onChangeReleaseHoldAt={onChangeReleaseHoldAt}
        />
        <div className="fw-500 mt-2 c-tint3">
          <div className="fw-500 mt-2 c-tint3">
            {status === "indefinite_hold" ? (
              "No donations will occur until this hold is released."
            ) : status === "hold_until" || status === "active" ? (
              <span>
                <span>Your next donation will be </span>
                <NextOccurrence
                  schedule={schedule}
                  releaseHoldAt={status === "hold_until" ? releaseHoldAt : null}
                  nextOccurrence={nextOccurrence}
                  onChangeNextOccurrence={onChangeNextOccurrence}
                />
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
